(function () {
  var visitorKey = 'pagan_interest_visitor_id_v1';
  var pendingTag = 'interest_segment_pending';
  var bridgePrefix = 'interest_vid_';
  var uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

  function prepareNewsletterForm(form) {
    var email = form.querySelector('input[name="contact[email]"]');
    if (!email) return;

    var visitorId;
    try {
      visitorId = window.localStorage.getItem(visitorKey);
    } catch (error) {
      return;
    }

    if (!uuidPattern.test(visitorId || '')) return;

    var tagsInput = form.querySelector('input[name="contact[tags]"]');
    if (!tagsInput) {
      tagsInput = document.createElement('input');
      tagsInput.type = 'hidden';
      tagsInput.name = 'contact[tags]';
      form.appendChild(tagsInput);
    }

    var tags = (tagsInput.value || '')
      .split(',')
      .map(function (tag) { return tag.trim(); })
      .filter(Boolean);

    [pendingTag, bridgePrefix + visitorId.toLowerCase()].forEach(function (tag) {
      if (tags.indexOf(tag) === -1) tags.push(tag);
    });
    tagsInput.value = tags.join(',');
  }

  document.addEventListener('submit', function (event) {
    if (event.target instanceof HTMLFormElement) prepareNewsletterForm(event.target);
  }, true);
})();

